import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LINKS = [
  { id: "work", label: "Work" },
  { id: "impact", label: "Impact" },
  { id: "services", label: "Services" },
  { id: "track-record", label: "Track Record" },
  { id: "writing", label: "Writing" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  const jump = (id) => {
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  const goHome = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-40 backdrop-blur-xl transition-colors ${
        scrolled ? "bg-[#F2EFE9]/90 hard-border-b" : "bg-[#F2EFE9]/60"
      }`}
    >
      {/* Row 1: logo + CTA */}
      <div className="flex items-center justify-between gap-4 px-5 md:px-10 lg:px-16 pt-4 pb-2 md:py-5">
        <button onClick={goHome} className="flex items-center shrink-0" data-testid="nav-logo">
          <span className="font-anton text-2xl md:text-3xl uppercase leading-none tracking-wide">JP Kuster</span>
        </button>

        {/* Desktop links inline with row 1 */}
        <nav className="hidden md:flex items-center gap-10 lg:gap-12">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => jump(l.id)}
              className="link-underline font-mono-s text-[11px] uppercase tracking-[0.22em]"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => jump("contact")}
          className="btn-offset shrink-0 !px-3 !py-2 !text-[10px] md:!px-5 md:!py-3 md:!text-xs"
          data-testid="nav-cta-contact"
        >
          Get in Touch <span aria-hidden>→</span>
        </button>
      </div>

      {/* Row 2: mobile-only scrollable sub-tab strip */}
      <nav
        className="md:hidden border-t border-[#111111]/40 overflow-x-auto scrollbar-none"
        data-testid="nav-mobile-strip"
        aria-label="Section navigation"
      >
        <div className="flex items-center gap-1 px-4 py-2 whitespace-nowrap min-w-max">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => jump(l.id)}
              className="font-mono-s text-[10px] uppercase tracking-[0.2em] px-3 py-2 hard-border bg-[#F2EFE9] hover:bg-[#E8E4DB] transition-colors"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      </nav>
    </header>
  );
}
